var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 3.1875C13.5747 3.1875 13.8125 3.42535 13.8125 3.71875C13.8125 4.01215 13.5747 4.25 13.2812 4.25H7.96875C7.67535 4.25 7.4375 4.01215 7.4375 3.71875C7.4375 3.42535 7.67535 3.1875 7.96875 3.1875H13.2812Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 6.375C13.5747 6.375 13.8125 6.61285 13.8125 6.90625C13.8125 7.19965 13.5747 7.4375 13.2812 7.4375H7.96875C7.67535 7.4375 7.4375 7.19965 7.4375 6.90625C7.4375 6.61285 7.67535 6.375 7.96875 6.375H13.2812Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 10.0938C13.8125 9.80035 13.5747 9.5625 13.2812 9.5625H7.96875C7.67535 9.5625 7.4375 9.80035 7.4375 10.0938C7.4375 10.3872 7.67535 10.625 7.96875 10.625H13.2812C13.5747 10.625 13.8125 10.3872 13.8125 10.0938Z",
    fill: "#4C4C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 12.75C13.5747 12.75 13.8125 12.9878 13.8125 13.2812C13.8125 13.5747 13.5747 13.8125 13.2812 13.8125H7.96875C7.67535 13.8125 7.4375 13.5747 7.4375 13.2812C7.4375 12.9878 7.67535 12.75 7.96875 12.75H13.2812Z",
    fill: "#4C4C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.125C17 0.951395 16.0486 0 14.875 0H2.125C0.951395 0 0 0.951395 0 2.125V14.875C0 16.0486 0.951395 17 2.125 17H14.875C16.0486 17 17 16.0486 17 14.875V2.125ZM4.25 1.0625V15.9375H2.125C1.5382 15.9375 1.0625 15.4618 1.0625 14.875V2.125C1.0625 1.5382 1.5382 1.0625 2.125 1.0625H4.25ZM5.3125 1.0625H14.875C15.4618 1.0625 15.9375 1.5382 15.9375 2.125V14.875C15.9375 15.4618 15.4618 15.9375 14.875 15.9375H5.3125V1.0625Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.918037831288a30e5b6d84769fda6cc8.svg";
export { ForwardRef as ReactComponent };